var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-icon-wrap",class:'company-' + _vm.type},[_c('span',{staticClass:"el-icon-office-building"})])}
var staticRenderFns = []

export { render, staticRenderFns }